var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41524_1393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 32C24.0604 32 31 24.8366 31 16C31 7.16344 24.0604 0 15.5 0C6.93959 0 0 7.16344 0 16C0 24.8366 6.93959 32 15.5 32Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1854 17.7055V23.1967H20.0715V18.0404C20.0715 16.768 19.6174 15.8975 18.5146 15.8975C17.6713 15.8975 17.1522 16.5002 16.9576 17.0359C16.8928 17.2368 16.8279 17.5046 16.8279 17.8395V23.1967H13.714C13.714 23.1967 13.7788 14.4912 13.714 13.6206H16.8279V14.9599C17.2171 14.2903 17.9956 13.3528 19.6174 13.3528C21.6285 13.3528 23.1854 14.759 23.1854 17.7055ZM10.4703 9C9.43235 9 8.71875 9.73662 8.71875 10.6741C8.71875 11.6117 9.36748 12.3483 10.4054 12.3483C11.5083 12.3483 12.157 11.6117 12.157 10.6741C12.2218 9.66966 11.5732 9 10.4703 9ZM8.91337 23.1967H12.0272V13.6206H8.91337V23.1967Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41524_1393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.b58f9b83d8658efbb5343044f2d120cc.svg";
export { ForwardRef as ReactComponent };